// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { stimulusApplication as application } from "packages/web"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import Animations__BusinessConnectController from "./animations/business_connect_controller"
application.register("animations--business-connect", Animations__BusinessConnectController)

import Animations__BusinessLandingController from "./animations/business_landing_controller"
application.register("animations--business-landing", Animations__BusinessLandingController)

import Animations__BusinessServiceController from "./animations/business_service_controller"
application.register("animations--business-service", Animations__BusinessServiceController)

import Animations__CustomerLandingController from "./animations/customer_landing_controller"
application.register("animations--customer-landing", Animations__CustomerLandingController)

import Animations__EnterController from "./animations/enter_controller"
application.register("animations--enter", Animations__EnterController)

import Animations__ParticlesController from "./animations/particles_controller"
application.register("animations--particles", Animations__ParticlesController)

import Animations__UseCasesController from "./animations/use_cases_controller"
application.register("animations--use-cases", Animations__UseCasesController)

import AriaExpandedController from "./aria_expanded_controller"
application.register("aria-expanded", AriaExpandedController)

import BudgetController from "./budget_controller"
application.register("budget", BudgetController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import CustomerController from "./customer_controller"
application.register("customer", CustomerController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import ElementController from "./element_controller"
application.register("element", ElementController)

import Form__InputController from "./form/input_controller"
application.register("form--input", Form__InputController)

import Form__TelInputController from "./form/tel_input_controller"
application.register("form--tel-input", Form__TelInputController)

import FormController from "./form_controller"
application.register("form", FormController)

import InputController from "./input_controller"
application.register("input", InputController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NewModalController from "./new_modal_controller"
application.register("new-modal", NewModalController)

import ReactiveTurboController from "./reactive_turbo_controller"
application.register("reactive-turbo", ReactiveTurboController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import StickyHeaderController from "./sticky_header_controller"
application.register("sticky-header", StickyHeaderController)

import TableController from "./table_controller"
application.register("table", TableController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ThoughtSpotController from "./thought_spot_controller"
application.register("thought-spot", ThoughtSpotController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
